import RejectedMedicines from 'components/RejectedMedicines';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

export const Rejected = () => {
  const selectedCompanyPermission = useSelector(
    (state: any) => state?.userProfile?.data?.permissions
  );
  const isRejectedPermission = checkPermission(selectedCompanyPermission, {
    permissionName: 'Rejected',
    permission: ['view', 'viewAll'],
  });
  return <div>{isRejectedPermission && <RejectedMedicines />}</div>;
};
